<template>
  <div class="home-container container-wrap">
    <bayes-head-top>
    </bayes-head-top>
    <div class="content" style="padding-top: 0;">
      <div class="message">
        <i class="el-icon-warning"></i>项目全面焕新 💣，超越过往想象，以颠覆式升级 🚀，重塑行业新标杆。了解更多请点击 <span @click="skipToNewEasyAdsPro()">【EasyAds Pro】</span>
      </div>
      <div class="main-container markdown-container">
        <div v-html="html" class="main"></div>
        <div id="adsgoeshere" v-html="adsenseContent" class="ads"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import readMe  from '../../assets/easyads_home.md';
export default {
  data () {
    return {
      md: readMe,
      html: '',
      adsenseContent: ''
    }
  },

  mounted () {
    let converter = new showdown.Converter()
    let text = this.md.toString()
    this.html = converter.makeHtml(text);

    //显示Google广告
    this.adsenseContent = document.getElementById('divadsensedisplaynone').innerHTML;
  },

  methods: {
    skipToNewEasyAdsPro() {
      window.open('http://easyads-pro.bayescom.cn/');
    }
  },

  components: {
    showdown
  }
}
</script>

<style lang="scss" scoped>
.home-container {

  .main-container {
    position: relative;
    .ads {
      position: absolute;
      height: 420px;
      width: 250px;
      top: 0;
      right: 0;
      text-align: center;
    }
  }

  .message {
    border: 1px solid #fee5b9;
    border-radius: 5px;
    padding: 15px 20px;
    background-color: #fefbea;
    font-size: 24px;
    .el-icon-warning {
      color: #eabd72;
      vertical-align: text-top;
      margin-right: 5px;
    }

    .el-icon-warning:before {
      font-size: 30px;
    }

    span {
      color: #2944bc;
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/home/index.vue